import { ChecklistIcon, EmptyChecklistIcon, MixedChecklistIcon } from "@xola/icons";
import { ButtonGroup, Tooltip } from "@xola/ui-kit";
import React from "react";

export type InventoryStatus = "all" | "published" | "draft";

interface InventoryStatusFilterProps {
    value: InventoryStatus;
    onChange: (value: InventoryStatus) => void;
}

const items = [
    { key: "published" as InventoryStatus, name: "Published", icon: ChecklistIcon },
    { key: "draft" as InventoryStatus, name: "Draft", icon: EmptyChecklistIcon },
    { key: "all" as InventoryStatus, name: "All", icon: MixedChecklistIcon },
];

export const InventoryStatusFilter = ({ value, onChange }: InventoryStatusFilterProps) => {
    const activeIndex = items.findIndex((item) => item.key === value);

    const handleChange = (index: number) => {
        onChange(items[index].key);
    };

    return (
        <ButtonGroup isCollapsed className="align-top" size="small" value={activeIndex} onChange={handleChange}>
            {items.map((item, index) => {
                const Icon = item.icon;
                return (
                    <ButtonGroup.Button
                        key={item.key}
                        className="h-7.5 px-2.5 text-base"
                        data-testid={`inventory-status-filter-${item.key}`}
                    >
                        <Tooltip offset={[0, 18]} content={item.name} disabled={activeIndex === index}>
                            <div className="w-full space-x-1">
                                <Icon size="medium" /> {activeIndex === index && item.name}
                            </div>
                        </Tooltip>
                    </ButtonGroup.Button>
                );
            })}
        </ButtonGroup>
    );
};
